// extracted by mini-css-extract-plugin
export default {"root":"Root_root__TvRAu","loaderContainer":"Root_loaderContainer__yAB5L"};